import React, { useState } from 'react';
import styles from './AdminProductSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { userSingle } from '../../../redux/actions/user/userSingle';
import { resetUserSingle } from '../../../redux/slices/user.slice';
import { resetPostSingle, resetProductSingle } from '../../../redux/slices/app.slice';
import { postSingle } from '../../../redux/actions/app/postSingle';
import dayjs from 'dayjs';
import { productSingle } from '../../../redux/actions/app/productSingle';

const AdminProductSingle = () => {
  const data = [
    {
      label: 'Фото',
      type: 'image',
      name: 'image',
      width: '400px',
    },
    { label: 'Галерея', type: 'gallery', name: 'images' },
    {
      label: 'Название',
      type: 'text',
      name: 'title',
      disabled: true,
    },

    {
      label: 'Стоимость',
      type: 'number',
      name: 'cost',
      disabled: true,
    },
  ];
  const [fields, setFields] = useState([]);
  const onFormatData = ({ product: { cityId, city, video, cost, description, title, images, image, creator, createdAt, characteristics } }) => {
    const cityField = {
      label: 'Город',
      type: 'select',
      name: 'cityId',
      disabled: true,
      options: [
        {
          label: city?.name,
          value: city?.id,
        },
      ],
    };
    const charsFields = [];
    let charsValue = {};
    characteristics?.map((char) => {
      charsValue = {
        ...charsValue,
        [char.id]: {
          label: char?.name,
          value: char?.value,
        },
      };
      charsFields?.push([
        {
          type: 'text',
          name: `chars.${char.id}.label`,
          disabled: true,
        },
        {
          type: 'text',
          name: `chars.${char.id}.value`,
          disabled: true,
        },
      ]);
    });
    const otherFields = [
      {
        label: 'Ссылка на видео (не обязательно)',
        type: 'text',
        name: 'video',
        disabled: true,
      },
      [
        {
          type: 'image',
          name: 'avatar',
          width: '40px',
          grid: '40px 1fr',
        },
        {
          label: 'Создатель',
          type: 'text',
          name: 'user',
          disabled: true,
        },
      ],
      {
        label: 'Описание',
        type: 'textarea',
        name: 'description',
        disabled: true,
      },
      {
        label: 'Дата публикации',
        type: 'text',
        name: 'createdAt',
        disabled: true,
      },
      {
        label: 'Характеристики',
        type: 'title',
      },
      ...charsFields,
    ];
    setFields([...data, cityField, ...otherFields]);
    return { chars: charsValue, cityId, video, cost, title, images, image, description, user: `${creator?.lastName} ${creator?.firstName}`, avatar: creator?.avatar, createdAt: dayjs(createdAt).format('DD.MM.YYYY HH:mm') };
  };
  const deleteProps = { successText: 'Товар удален', confirmTitle: `Вы уверены что хотите удалить товар`, confirmText: 'Комментарии также будут удалены', status: 'DELETED' };
  const blockProps = { successText: 'Товар заблокирован', confirmTitle: `Вы уверены что хотите заблокировать товар`, confirmText: 'Комментарии также будут заблокированы', status: 'BLOCKED' };
  const unblockProps = { successText: 'Товар разблокирован', confirmTitle: `Вы уверены что хотите разблокировать товар`, confirmText: 'Комментарии также будут разблокированы', status: 'ACTIVE' };
  return (
    <>
      <AdminSinglePage
        reset={resetProductSingle}
        fetch={productSingle}
        sliceName={'app'}
        actionName={'productSingle'}
        onFormatData={onFormatData}
        fields={fields}
        pathList="/admin/products"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'product'}
        type={'PRODUCT'}
      />
    </>
  );
};

export default AdminProductSingle;
